import React from 'react'
import "./Download.css";
import { Container, Row, Col } from 'react-bootstrap';

const Download = () => {
    return (
        <section className='download_section section_margin'>
            <Container>
                <div className='section'>
                    <Row>
                        {/* Left Column */}
                        <Col md={8}>
                            <div className='text_area'>
                                <h5 className='top_text'>
                                    Simple, intuitive interface designed for a<br /> hassle-free experience.
                                </h5>
                                <h2 className='download_text'>
                                    Over <span>1,000,000+ </span>Downloads & Counting!
                                </h2>

                                <hr className='divider' />
                                <div className="play_store_img_text_holder">

                                    <p className='prompt'>Download and <br /> Start Today</p>

                                    <div className='store_buttons'>
                                        <img src='./assets/images/home/download/google_play.png' alt='Google_play' className='store' />
                                        <img src='./assets/images/home/download/app_store.png' alt='App_store' className='store' />
                                    </div>
                                </div>

                                {/* Right column */}
                                <Col md={4}>
                                    <div className='image_area'>
                                        <img src='/assets/images/home/download/mobile.png' alt='Mobile' className='phone_image' />
                                    </div>
                                </Col>

                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}

export default Download